import * as React from 'react';
import clsx from 'clsx';
import { WithTranslation, withTranslation } from 'react-i18next';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { IObjectRouteParams, routes } from 'routes';
import { connect } from 'react-redux';
import {
    PanelHeader,
    PanelBody,
    PanelFooter,
    Button,
    Icons,
    ButtonGroup,
    CloseButton,
    LinkButton,
    Preloader, Panel
} from 'components';
import { IState } from 'services/root-reducer';
import { EOperationStatus, IAppConfig, IObjectSignature } from 'types';
import {
    BaseLayerCode, ComparableLayers, favouritesContainersCodes, pdfContainerCodes, FolderCode
} from 'project-constants';
import {
    getOmjsLayerConfig,
    getLayerIcon,
    getTopContainer,
    getFavorites, getOmjsContainer, getLayerObject, getOperationData, getOmjsViewInstance, getOperationStatus
} from 'selectors';
import { actions as mapActions } from 'services/map/map-service';
import { actions as favoritesActions } from 'services/favorites/favorites-service';
import { actions as overlayWindowsActions } from 'services/overlay-windows/overlay-windows-service';
import { actions as containersActions } from 'services/containers/containers-service';
import { actions as appActions } from 'services/app/app-service';
import { ObjectWindowTab } from 'scenes/object-window';
import { SlideUpPanel } from 'mobile-ui/components/slideup-panel';
import { ObjectsHelper, formatApiUrl } from 'utils';
import { actions as objectWindowActions } from 'services/object-window/object-window-service';
import { ObjectGenPlanyInfo } from 'scenes/object-window-gen-plany/object-info';
import i18next from 'i18next';

import './style.scss';
import { CSSTransition } from 'react-transition-group';

/* eslint-disable-next-line */
export interface IMobileUIObjectGenPlanyWindowOwnProps extends RouteComponentProps<IObjectRouteParams>, WithTranslation {
    onZoomToObject: (sig: IObjectSignature) => void;
}

export interface IMobileUIObjectGenPlanyWindowProps extends IMobileUIObjectGenPlanyWindowOwnProps {
    allContainers: IState['operations']['CONTAINERS']['data'];
    genPlanes: IState['operations']['GEN_PLANES']['data'];
    gpStatus: EOperationStatus;
    folderState: any;
    apiUrlWithVersion: string;
    config: IAppConfig;
    favorites: IState[ 'favorites' ][ 'items' ];
    isInFavorites: boolean;
    layerCode: string;
    objectId: number;
    object: ReturnType<typeof getLayerObject>;
    layerConfig: ReturnType<typeof getOmjsLayerConfig>;
    currentZoom: number
}

export interface IMobileUIObjectGenPlanyWindowState {
    minimized: boolean;
}

const mapStateToProps = (state: IState, ownProps: IMobileUIObjectGenPlanyWindowOwnProps) => {
    let { match } = ownProps;
    const objectId = parseInt(match.params.objectId);
    const { layerCode } = match.params;

    let { config } = state.app;
    let favorites = getFavorites(state);
    let in_favorites = favorites[layerCode]?.includes(objectId) ?? false;

    return {
        allContainers: getOperationData(state, 'CONTAINERS'),
        genPlanes: getOperationData(state, 'GEN_PLANES'),
        gpStatus: getOperationStatus(state, 'GEN_PLANES'),
        apiUrlWithVersion: formatApiUrl(config.apiUrl),
        folderState: getOperationData(state, 'FOLDER_STATE'),
        config: config,
        favorites: getFavorites(state),
        isInFavorites: in_favorites,
        layerCode: layerCode,
        objectId: objectId,
        object: getLayerObject(state, layerCode, objectId),
        layerConfig: getOmjsLayerConfig(state, layerCode),
        currentZoom: getOmjsViewInstance(state).getMap().getView().getZoom()
    };
};

/* eslint-disable */
class MobileUIObjectGenPlanyWindowComponent extends React.Component<
    IMobileUIObjectGenPlanyWindowProps,
    IMobileUIObjectGenPlanyWindowState
> {
/* eslint-enable */

    constructor(props: IMobileUIObjectGenPlanyWindowProps) {
        super(props);

        this.state = this.getInitialState();

        this.onCloseClick = this.onCloseClick.bind(this);
        this.onZoomToObjectClick = this.onZoomToObjectClick.bind(this);
        this.onLinkClick = this.onLinkClick.bind(this);
        this.onPDFClick = this.onPDFClick.bind(this);
        this.onFavoritesClick = this.onFavoritesClick.bind(this);
        this.onDataUpdateClick = this.onDataUpdateClick.bind(this);
    }

    getInitialState(): IMobileUIObjectGenPlanyWindowState {
        return {
            minimized: false
        };
    }

    componentDidMount() {
        let { layerCode, objectId } = this.props.match.params;

        if (!ComparableLayers.has(layerCode)) {
            mapActions.getConnections([ 0, 0 ]);
        } else {
            mapActions.getConnectionsByObject({
                layerCode: layerCode,
                objectId: parseInt(objectId)
            });
        }
    }

    componentDidUpdate(prevProps: Readonly<IMobileUIObjectGenPlanyWindowProps>) {
        let { layerCode, objectId } = this.props.match.params;
        let { layerCode: prevLayerCode, objectId: prevObjectId } = prevProps.match.params;

        if (!ComparableLayers.has(layerCode)) {
            mapActions.getConnections([ 0, 0 ]);
        }

        if (layerCode !== prevLayerCode || objectId !== prevObjectId) {
            /* eslint-disable-next-line */
            this.setState(this.getInitialState());

            if (ComparableLayers.has(layerCode)) {
                mapActions.getConnectionsByObject({
                    layerCode: layerCode,
                    objectId: parseInt(objectId)
                });
            }
        }
    }

    getGenplanContainer() {
        return this.props.allContainers.find(c => c.code === FolderCode['GEN_PLANS_OBJECTS']);
    }

    onPDFClick() {
        let {
            apiUrlWithVersion,
            config,
            i18n,
            layerCode,
            objectId
        } = this.props;

        let topContainer = getTopContainer(false, layerCode);

        // код оригинального слоя, по которому созданы виртуальные слои категорий
        let baseLayerCode = BaseLayerCode[topContainer.get('code')] || layerCode;

        let path = `${apiUrlWithVersion + config.mapCode}/layers/${baseLayerCode}/objects/${objectId}/`;
        let query = `f=pdf&custom=1&lng=${i18n.language}&dl=1`;

        window.open(`${path}?${query}`);
    }

    onLinkClick() {
        let { i18n, layerCode, objectId } = this.props;

        let object_link = ObjectsHelper.getObjectLink({
            layer_code: layerCode,
            object_id: objectId
        });

        overlayWindowsActions.showObjectLinkOverlay(object_link);
    }

    onCloseClick(event: React.MouseEvent) {
        let { layerCode } = this.props;
        const { navigation } = routes;
        let removeNavItem = false;

        if (navigation.length) {
            removeNavItem = navigation[navigation.length - 1].params.objectId !== undefined;
            if (navigation[navigation.length - 1].route.path.indexOf('/list/') === 0) {
                let listLayerCode = navigation[navigation.length - 1].params.layerCode;
                let topContainerCode = getTopContainer(false, layerCode).get('code');
                removeNavItem = (
                    removeNavItem || (layerCode !== listLayerCode && topContainerCode !== listLayerCode)
                );
            }
        }

        while (removeNavItem) {
            routes.navigation.pop();
            if (navigation.length) {
                removeNavItem = navigation[navigation.length - 1].params.objectId !== undefined;
                if (navigation[navigation.length - 1].route.path.indexOf('/list/') === 0) {
                    let listLayerCode = navigation[navigation.length - 1].params.layerCode;
                    let topContainerCode = getTopContainer(false, layerCode).get('code');
                    removeNavItem = (
                        removeNavItem || (layerCode !== listLayerCode && topContainerCode !== listLayerCode)
                    );
                }
            }
        }
        routes.goBack(routes.map, { container: 'root' }, routes.currRouteState);
    }

    onZoomToObjectClick() {
        let { object, objectId, layerCode } = this.props;
        this.props.onZoomToObject({ layer_code: layerCode, object_id: objectId });

        const cont = getOmjsContainer(false, layerCode, true);

        if (!cont || !object) {
            console.warn('[onZoomToObjectClick]', { cont, object });
            return;
        }

        if (cont.get('render_type') === 0) {
            const objGeom = object.getGeometry();
            const geom = new omjs.ol.geom[objGeom.type](objGeom.coordinates);
            mapActions.fitToExtent(geom.getExtent());
        } else {
            mapActions.fitToTarget({
                layer: layerCode,
                objectId: objectId
            });
        }
        this.setState({
            minimized: true
        });
    }

    onFavoritesClick() {
        let { isInFavorites } = this.props;
        let { objectId, layerCode } = this.props;

        if (isInFavorites) {
            favoritesActions.removeItem({ layer_code: layerCode, object_id: objectId });
        } else {
            favoritesActions.addItem({ layer_code: layerCode, object_id: objectId });
        }
    }

    onDataUpdateClick() {
        let { object, layerCode } = this.props;

        let layerConfig = getOmjsLayerConfig(false, layerCode);

        if (!layerConfig || !object) {
            console.warn('[onDataUpdateClick]', { layerConfig, object });
            return;
        }

        overlayWindowsActions.showUpdateDataOverlay({
            layer_code: layerCode,
            object_id: object.id,
            object_name: ObjectsHelper.getObjectName(object, layerConfig),
            object_url: ObjectsHelper.getObjectLink({
                layer_code: layerCode,
                object_id: object.id
            })
        });
    }

    renderPreloader() {
        return (
            <Panel className={clsx('object-window-wrapper', 'preloader-wrapper')}>
                <Preloader />
            </Panel>
        );
    }

    renderError() {
        let { t } = this.props;
        return (
            <React.Fragment>
                <PanelHeader className='window-header'>
                    <div className="tabs-switcher"></div>
                    <div className="close-button-wrapper">
                        <CloseButton onClick={this.onCloseClick} />
                    </div>
                </PanelHeader>

                <PanelBody className='error window-body'>
                    <div className='error-message'>
                        {t('Ошибка загрузки')}
                    </div>
                </PanelBody>
            </React.Fragment>
        );
    }

    renderPanel() {
        let {
            isInFavorites,
            object,
            layerConfig,
            allContainers,
            layerCode,
            objectId,
            folderState,
            currentZoom,
            gpStatus
        } = this.props;

        let container = this.getGenplanContainer();

        if (!container || !object || !layerConfig) {
            console.warn({ container, object, layerConfig });
            return this.renderError();
        }

        let objectName = ObjectsHelper.getObjectName(object, layerConfig);
        let rootContainer = allContainers.find(c => c.name === objectName);

        if (gpStatus === EOperationStatus.PENDING) {
            return this.renderPreloader();
        }

        if (!rootContainer && currentZoom >= 12) {
            console.warn({ rootContainer });
            return this.renderError();
        }

        return (
            <React.Fragment>
                <div className="layer-icon-name-wrapper">
                    <div className="layer-icon">
                        <img
                            src={getLayerIcon(false, {
                                layer_code: layerCode,
                                object_id: objectId
                            })}
                        />
                    </div>
                    <div
                        className="layer-name"
                        dangerouslySetInnerHTML={{
                            __html: ObjectsHelper.getObjectName(object, layerConfig)
                        }}
                        onClick={() => this.setState({ minimized: false })}
                    />
                    <div className="close-button-wrapper">
                        <CloseButton onClick={this.onCloseClick} />
                    </div>
                </div>
                {currentZoom < 12 && !this.state.minimized && (
                    <div className="gen-plany-zoom-message">
                        {i18next.t('Для управления слоями приблизьтесь к территории')}
                    </div>
                )}
                <PanelBody className='window-body'>
                    {currentZoom >= 12 && (
                        <CSSTransition
                            in
                            classNames="animation-state"
                            timeout={200}
                        >
                            <ObjectGenPlanyInfo
                                currentZoom={currentZoom}
                                className='slide-right-animation'
                                allContainers={allContainers}
                                folderState={folderState}
                                rootContainer={rootContainer}
                                onContainerExpand={(id, isChecked) => {
                                    appActions.setFolderState({
                                        id: id, state: isChecked
                                    });
                                }}
                                onSelectedChange={(id, isSelected) => {
                                    containersActions.setContainerSelected({
                                        id_or_code: id, selected: isSelected
                                    });
                                }}
                            />
                        </CSSTransition>
                    )}
                </PanelBody>
                <PanelFooter className='object-window-footer'>
                    <ButtonGroup>
                        <Button
                            variant='blue'
                            onClick={this.onZoomToObjectClick}
                            icon={<Icons.IconMagnifyGlassPlus />}
                        />
                        {
                            !__IS_CORDOVA__ && (
                                <Button
                                    variant='blue'
                                    onClick={this.onLinkClick}
                                    icon={<Icons.IconLink />}
                                />
                            )
                        }
                        {pdfContainerCodes.includes(layerCode) && (
                            <Button
                                variant='blue'
                                onClick={this.onPDFClick}
                                icon={<Icons.IconPdf />}
                            />
                        )}
                        {favouritesContainersCodes.includes(layerCode) && (
                            <Button
                                variant="blue"
                                onClick={this.onFavoritesClick}
                                className={clsx({
                                    'in-favorites-icon-color': isInFavorites
                                })}
                                icon={<Icons.IconStar />}
                            />
                        )}
                    </ButtonGroup>
                </PanelFooter>
            </React.Fragment>
        );
    }

    render() {
        return (
            <SlideUpPanel
                open
                className={clsx(
                    'mobile-ui-object-window',
                    'gen-plany-mobile-window',
                    {
                        'minimized': this.state.minimized
                    }
                )}
            >
                { this.renderPanel() }
            </SlideUpPanel>
        );
    }
}

export const MobileUIObjectGenPlanyWindow = withRouter(
    // @ts-ignore
    withTranslation()(
        connect(mapStateToProps)(MobileUIObjectGenPlanyWindowComponent)
    )
);
